import {
  DefaultButton,
  Link,
  mergeStyles,
  MessageBar,
  MessageBarType,
  Spinner,
  SpinnerSize,
  Stack,
  Text,
} from "@fluentui/react";
import { styles } from "../rolloutDetailsTable.styles";
import { useState } from "react";
import ConfigPipelineDialog from "./ConfigPipelineDialog";
import { useToast } from "../../../../Contexts/ToastContext";
import { useFetchPipelineConfigOpenPrs } from "../../../../Hooks/AdoHooks/UseFetchExperiments";
import { REPO_URL } from "../../../../Shared/shared.consts";
import useAppInsights from "../../../../Hooks/UseAppInsights";
import { NavType } from "../../../../Shared/AppInsights";
interface ConfigurePipelineOverviewProps {}
const ConfigurePipelineOverview: React.FC<
  ConfigurePipelineOverviewProps
> = () => {
  const { showToast } = useToast();
  const [error, setError] = useState<string | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const { trackNavigationEvent, trackOperationEvent } = useAppInsights(
    "ConfigurePipelineOverview",
  );

  const onClickAddConfiguration = () => {
    setIsDialogOpen(true);
    trackOperationEvent({
      operation: "OpenConfigPipelineDialog",
      function: "onClickAddConfiguration",
      properties: {
        dialogComponent: "ConfigPipelineDialog",
      },
    });
  };

  const {
    value: configPr,
    loading,
    refresh,
  } = useFetchPipelineConfigOpenPrs(setError);

  const onSuccess = () => {
    showToast({
      message: "Pipeline configuration was successful.",
      type: "success",
      duration: 5000,
      dismissible: true,
    });
    refresh();
  };

  return (
    <>
      <Stack tokens={{ childrenGap: 10, padding: "10px 0 0 0" }}>
        <MessageBar messageBarType={MessageBarType.warning}>
          Pipeline IDs are not configured for this extension.
        </MessageBar>
        <Stack
          className={mergeStyles(styles.rolloutDetailsTableEmpty)}
          horizontalAlign="center"
          tokens={{ childrenGap: 20 }}
        >
          {loading ? (
            <Spinner
              label="Loading Configuration..."
              size={SpinnerSize.medium}
            />
          ) : error ? (
            <MessageBar messageBarType={MessageBarType.error}>
              Error loading configuration: {error}
            </MessageBar>
          ) : configPr ? (
            // Configuration PR exists
            <>
              <Text>
                There is an open{" "}
                <Link
                  href={configPr.prUrl || undefined}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    trackNavigationEvent({
                      destination: configPr.prUrl ?? "",
                      navType: NavType.External,
                    });
                  }}
                >
                  Pull Request
                </Link>{" "}
                to configure pipeline IDs for this extension.
              </Text>
              <DefaultButton onClick={onClickAddConfiguration}>
                View Configuration
              </DefaultButton>
            </>
          ) : (
            // Configuration PR does not exist
            <>
              <Stack tokens={{ childrenGap: 10 }} horizontalAlign="center">
                <Text>
                  To enable pipelines, please add a pipelineIds.json file to
                  your extension in,
                </Text>
                <Link
                  href={REPO_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => {
                    trackNavigationEvent({
                      destination: REPO_URL,
                      navType: NavType.External,
                    });
                  }}
                >
                  AzureUX-Experimentation
                </Link>
              </Stack>
              <DefaultButton onClick={onClickAddConfiguration}>
                Add Configuration
              </DefaultButton>
            </>
          )}
        </Stack>
      </Stack>
      {isDialogOpen && (
        <ConfigPipelineDialog
          onCancel={() => setIsDialogOpen(false)}
          onSuccess={onSuccess}
          configuration={configPr}
        />
      )}
    </>
  );
};
export default ConfigurePipelineOverview;
